import React from "react";
import { useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";
import { MainContainer, FoodItemsContainer, MenuContainer } from "../components";
import { rowItems } from "../data/dummyData";
const Home = () => {
  const { foodItems } = useSelector((state) => state.product);

  return (
    <>
      <MainContainer />
      {foodItems ? (
        <>
          {rowItems.map((item, idx) => (
          <FoodItemsContainer
            key={idx}
            dataKey={item.dataKey}
            title={item.title}
            foodItems={foodItems}
            flag={item.flag}
          />
          ))}
          <MenuContainer />
        </>
      ) : (
        <div className="flex justify-center items-center mt-10">
          <SyncLoader color="#f97316" />
        </div>
      )}
    </>
  );
};

export default Home;
